import { createRouter, createWebHistory } from 'vue-router';
import Login from '../components/Login.vue';
import Dashboard from '../components/Dashboard.vue';
import Tables from '../components/Tables.vue';
import Invitees from '../components/Invitees.vue';
import Donations from '../components/Donations.vue';

const routes = [
  { path: '/', name: 'Login', component: Login },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/tables', name: 'Tables', component: Tables },
  { path: '/invitees', name: 'Invitees', component: Invitees },
  { path: '/donations', name: 'Donations', component: Donations },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
